package com.essntl.features.paymentparameter.ui.paymentparameter

import com.essntl.features.paymentparameter.domain.model.PaymentParameterModel

sealed interface PaymentParameterNavigation {
    data object AddPaymentParameter : PaymentParameterNavigation
    data class EditPaymentParameter(val p: PaymentParameterModel) : PaymentParameterNavigation
}